import boldNeutralsDark from "../../../../src/pages/rovo-ui/color/_assets/bold-neutrals-dark.png";
import boldNeutralsLight from "../../../../src/pages/rovo-ui/color/_assets/bold-neutrals-light.png";
import brandColorsDark from "../../../../src/pages/rovo-ui/color/_assets/brand-colors-dark.png";
import brandColorsLight from "../../../../src/pages/rovo-ui/color/_assets/brand-colors-light.png";
import brandColorsMicAnnotationDark from "../../../../src/pages/rovo-ui/color/_assets/brand-colors-mic-annotation-dark.png";
import brandColorsMicAnnotationLight from "../../../../src/pages/rovo-ui/color/_assets/brand-colors-mic-annotation-light.png";
import mosaicCursorDoDark from "../../../../src/pages/rovo-ui/color/_assets/mosaic-cursor-do-dark.png";
import mosaicCursorDoLight from "../../../../src/pages/rovo-ui/color/_assets/mosaic-cursor-do-light.png";
import mosaicCursorDontDark from "../../../../src/pages/rovo-ui/color/_assets/mosaic-cursor-dont-dark.png";
import mosaicCursorDontLight from "../../../../src/pages/rovo-ui/color/_assets/mosaic-cursor-dont-light.png";
import * as React from 'react';
export default {
  boldNeutralsDark,
  boldNeutralsLight,
  brandColorsDark,
  brandColorsLight,
  brandColorsMicAnnotationDark,
  brandColorsMicAnnotationLight,
  mosaicCursorDoDark,
  mosaicCursorDoLight,
  mosaicCursorDontDark,
  mosaicCursorDontLight,
  React
};